import React, {
    JSX,
    useEffect,
} from "react";
import { ScrollController } from "../../utils/ScrollController";
import { normalizeClassName } from "../../render/renderUtils";
import './RydViewport.css';

function RydViewportSticky({
    children
} :{
    children?: JSX.Element
}) {
    return (<div className='ryd-viewport-sticky'>
        <span style={{ color: 'black' }}>Sticky</span>

    </div>);
}

function RydViewport({
    name,
    adaptiveHeight,
    scrollController,
    header,
    sticky,
    children,
    hideTitle = false
}: {
    name: string,
    adaptiveHeight?: boolean,
    scrollController?: ScrollController,
    header?: JSX.Element,
    sticky?: JSX.Element,
    children?: JSX.Element,
    hideTitle?: boolean
}) {

    const [containerHeight, setContainerHeight] = React.useState(480);
    const scrollableContentRef = React.useRef(null);
    const [listenerId, setListenerId] = React.useState<number>();

    // FIXME: Since Chrome doens't fucking allow use of dataTransfer in onDragStart,
    // this hacks around it to allow resizing of the viewport.
    let startX = 0;
    let startY = 0;

    const heightSpec = adaptiveHeight ? {} : {
        height: `${containerHeight}px`
    };
    const viewportClasses = ['ryd-viewport-content', 'ryd-content-background'];

    useEffect(() => {
        if (!scrollController) return;
        const newListenerId = scrollController.listen((n) => {
            if (!scrollableContentRef || !scrollableContentRef.current) return;
            (scrollableContentRef.current as HTMLElement).scrollLeft = n;
        });
        setListenerId(newListenerId);
    }, [scrollController]);

    useEffect(() => {
        if (!listenerId) return;
        scrollController?.drop(listenerId);
    }, []);

    return (<div style={{ display: 'flex', flexDirection: 'column'}}>
        <div className="ryd-container--window-wrapper"
        style={{
            right: '0px',
        }}>
            <div className='ryd-container'
                style={{
                    ...heightSpec,
                    right: '0px',
                    left: '0px',
                    position: 'relative',
            }}>
                {!hideTitle && <>
                    {name}
                </>}
                {header ? header : <></>}
                <div className='ryd-viewport'>
                    <div className="ryd-viewport-sticky">
                        {sticky}
                    </div>
                    <div ref={scrollableContentRef}
                        className={normalizeClassName(viewportClasses)}
                        onScroll={(e) => {
                            if (!scrollController) return;
                            scrollController.update(e.currentTarget.scrollLeft);
                        }}>
                        {children}
                    </div>
                </div>
            </div>
            <div className="ryd-container--width-handle" draggable="true"
                onDragStart={(e: { clientX: number, dataTransfer: any }) => {
                    startX = e.clientX;
                }}
                onDragEnd={(e) => {
                    const diff = e.clientX - startX;
                }} />
        </div>
        {!adaptiveHeight && <div className="ryd-container--height-handle" draggable="true"
            onDragStart={(e: { clientY: number, dataTransfer: any }) => {
                startY = e.clientY;
            }}
            onDragEnd={(e) => {
                const diff = e.clientY - startY;
                setContainerHeight(containerHeight + diff);
            }} />}
    </div>);
}

export {
    RydViewport,
    RydViewportSticky
};